import { DatePicker, Input, Button, Select, Option, Popover } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';

export default {
    name: 'filterBar',
    props: ['selectedYear', 'organizations', 'distances', 'races', 'racesFiltered'],
    components: {
        [DatePicker.name]: DatePicker,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Popover.name]: Popover
    },
    data() {
        return {
            eventTypes: ['All', 'Charity Organised Event', 'Club Organised Event', 'Commercial Organised Event'],
            page: 1,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filterInput: null,
            selectedDistance: null,
            selectedTypeByEvent: null,
            selectedOrganizationName: null,
            startDateRange: ''
        };
    },
    computed: {
        defaultDateRange() {
            if (this.startDateRange && this.startDateRange.length && this.startDateRange[0].getFullYear && this.startDateRange[0].getFullYear() != this.selectedYear) {
                this.startDateRange = '';
            }
            return new Date(this.selectedYear, 0, 1);
        },
        from() {
            if (!this.races || !this.races.length || !this.races[0].id) {
                return 0;
            }
            var res = (this.page - 1) * this.perPage + 1;
            if (res >= this.racesFiltered.length) {
                if (this.racesFiltered.length - this.perPage > 0) {
                    res = this.racesFiltered.length - this.perPage;
                    if (res === 0) {
                        res = 1;
                    }
                }
                else {
                    res = 1;
                    this.page = 1;
                }
            }
            return res;
        },
        to() {
            if (!this.races || !this.races.length || !this.races[0].id) {
                return 0;
            }
            return this.racesFiltered.length > (this.page - 1) * this.perPage + this.perPage ? (this.page - 1) * this.perPage + this.perPage : this.racesFiltered.length;
        },
        total() {
            if (!this.races || !this.races.length || !this.races[0].id) {
                return 0;
            }

            return this.racesFiltered.length;
        }
    },
    methods: {
        showError(message) {
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger',
                timeout: 100000
            });
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 10000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        previousPage() {
            this.page--;
            this.changePage(this.page)
        },
        nextPage() {
            this.page++;
            this.changePage(this.page)
        },
        changePage(newPage) {
            EventBus.$emit('admin-ranking-change-page', newPage, this.perPage);
            EventBus.$emit('user-ranking-change-page', newPage, this.perPage);
        },
        searchForRaces() {
            var updateModel = {
                selectedTypeByEvent: this.selectedTypeByEvent,
                selectedOrganizationName: this.selectedOrganizationName,
                selectedDistance: this.selectedDistance,
                filterInput: this.filterInput,
                startDateRange: this.startDateRange,
                perPage: this.perPage,
                page: this.page
            };

            EventBus.$emit('admin-ranking-filter-updated', updateModel);
            EventBus.$emit('user-ranking-filter-updated', updateModel);
        },
        init() {
            this.selectedDistance = "All";
            this.selectedOrganizationName = "All";
            this.selectedTypeByEvent = "All";

            EventBus.$off('filter-bar-re-search');
            EventBus.$on('filter-bar-re-search', () => this.searchForRaces());
        }
    },
    mounted() {
        var self = this;
        self.init();

        EventBus.$off('filter-bar-update');
        EventBus.$on('filter-bar-update', () => { self.searchForRaces() });
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/ranking/filter-bar/filter-bar.js